import React, { Component } from 'react';

const css = oxygenCss({
  root: {
    position: 'relative',
    height: '100%'
  },
  wrapper: {
    position: 'relative',
    height: '100%'
  }
});

class AppContent extends Component {
  render() {
    return <div className={css.root}>{this.props.children}</div>;
  }
}

export default AppContent;



// WEBPACK FOOTER //
// ./src/js/components/AppContent.js